import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}

/**
 * VIRALZZZ draft safeguard for Horizon hero videos.
 * Reasserts the browser-safe autoplay attributes and retries playback after
 * page restores, tab visibility changes, and Shopify theme-editor reloads.
 */
function playViralzzzHeroVideos() {
  const heroVideos = document.querySelectorAll('#MainContent .hero video');

  for (const video of heroVideos) {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');

    const playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(() => {});
    }
  }
}

playViralzzzHeroVideos();
window.addEventListener('pageshow', playViralzzzHeroVideos);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) playViralzzzHeroVideos();
});
document.addEventListener('shopify:section:load', playViralzzzHeroVideos);
